// eslint-disable-next-line import/order
import { useBundleLoader } from "./bundle-loader";
import $ from "jquery";
// keep polyfills first
import "../polyfills/polyfills";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";
// TODO: Remove after transition to DsTooltip
import "bootstrap/js/dist/tooltip";
import { useCasinoCheckoutManager } from "@sazka/casino/js/core/casino-checkout-manager";
import { useGlobalVideoModal } from "@sazka/design-system/src/modal-video/mount-modal-video";
import { initMobileAppFunctions } from "@sazka/mobile-apps/mobile-app-functions";
import { initMobileAppFeatures } from "@sazka/mobile-apps/mobile-app-integration";
import { useAuthentication } from "@sazka/ng/authentication/composables/use-authentication";
import { ngAction } from "@sazka/ng/ng-integration";
import { initSelfExclusionButton } from "@sazka/ng/panic-button/core/self-exclusion";
import { usePlayerAccount } from "@sazka/ng/player/player-account";
import { useQuestionnaires } from "@sazka/shared-components/questionnaires/use-questionnaires";
import { useCollapse } from "@sazka/utils/collapse";
import { documentReady } from "@sazka/utils/document-ready";
import { useAppInsights } from "@sazka/utils/logger/app-insights";
import { sazkaAlert } from "@sazka/utils/sazka-alert";
import { Timer } from "@sazka/utils/timer";
import { useWebpBackgroundImages } from "@sazka/utils/webp-background-images";
import { overrideYupEmail } from "@sazka/utils/yup-email";
import { useNgLib } from "@/ng/use-ng-lib";
import { registerNotificationsWorker } from "@/notifications/register-notifications-worker";
import { useEditableVideosGdprOverlay } from "@/shared/components/editable-videos-gdpr-overlay";
import { useIdentityVerificationPopup } from "@/shared/components/identity-verification/use-identity-verification-popup";
import { useBreadcrumbs } from "@/shared/components/master-page/breadcrumbs";
import { useFixedHelp } from "@/shared/components/master-page/fixed-help";
import { useFooter } from "@/shared/components/master-page/footer";
import { useHeaderScrollFeatures } from "@/shared/components/master-page/header";
import { useMainMenu } from "@/shared/components/master-page/main-menu";
import { useNotifications } from "@/shared/components/master-page/notifications";
import { useChat } from "@/shared/components/master-page/use-chat";
import { useExponea } from "@/shared/components/master-page/use-exponea";
import { modalAsFancybox } from "@/shared/components/modal-fancybox";
import { useScrollTo } from "@/shared/components/scroll-to-animated";
import { useSearch } from "@/shared/components/search";
import { initSecondaryMenuSticker } from "@/shared/components/secondary-menu-sticker";
import { initSelectBoxIt, registerSelectBoxIt, useSelectBoxIt } from "@/shared/components/select-box";
import { useLazyLoading } from "@/shared/components/use-lazy-loading";
import { useAfterLoginHooks } from "@/shared/composables/use-after-login-hooks";
import { useWebAppInsights } from "@/shared/composables/use-web-app-insights";
import { useGdpr } from "@/shared/gdpr/use-gdpr";
import { Analytics } from "@/shared/utils/analytics/analytics";
import { handleDeepLinks } from "@/shared/utils/deep-link";
import { useStackedModal } from "@/shared/utils/use-stacked-modals";
import { useServiceWorker } from "./use-service-worker";
import { useVhUnitsCalculation } from "./vh-units";
import { useVue } from "./vue";

document.ready = (fn = () => {}) => documentReady(fn); // eslint-disable-line

const timer = new Timer();

// register tmp global types for Ticket Check APP
(window as any).$ = $;
(window as any).jQuery = $;
(window as any).sazkaAlert = sazkaAlert;
(window as any).initSelectBoxIt = initSelectBoxIt;
(window as any).sazka = { analytics: Analytics };
(window as any).ngAction = ngAction;

useBundleLoader().then(() => Analytics.bundlesLoaded());
useServiceWorker();
useWebAppInsights();
useVue({ mountUserMenu: true, mountLegalWarning: true });
registerSelectBoxIt();
useExponea().registerExponeaToWindow();
useChat().registerChatToWindow();
overrideYupEmail();

$(() => {
    useNgLib().then(() => {
        useAppInsights().trackMetric("NG_Loading_Time", timer.getTime());
    });
    useHeaderScrollFeatures();
    useLazyLoading();
    useWebpBackgroundImages();
    useSearch();
    useVhUnitsCalculation();
    useMainMenu();
    useAuthentication().initializeInterface();
    //useSecondaryMenu();
    initSecondaryMenuSticker();
    useCollapse();
    useSelectBoxIt();
    useFixedHelp();
    useStackedModal();
    useGlobalVideoModal();
    useScrollTo();
    useGdpr().init();
    useFooter();
    useBreadcrumbs();
    useNotifications();
    modalAsFancybox();
    useEditableVideosGdprOverlay();
    handleDeepLinks();

    initMobileAppFeatures();
    initMobileAppFunctions();
    usePlayerAccount();
    initSelfExclusionButton();
    useAfterLoginHooks();
    useIdentityVerificationPopup().init();
    useCasinoCheckoutManager();
    if (!environment.isInAppView) registerNotificationsWorker();

    // keep it last
    Analytics.domReady();

    // delayed execution
    setTimeout(() => {
        useQuestionnaires();
    }, 1500);
});
